import React from 'react';
import { Redirect } from 'expo-router';

// Preserve links delivered before tasks received their own route.
export default function OperationsRedirect() {
  return <Redirect href="/(app)/tasks" />;
}
